"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gqlFragments = void 0;
/* Queries */
var getMatchesByFilters_1 = __importDefault(require("./gql/query/getMatchesByFilters"));
var getMatchBySlug_1 = __importDefault(require("./gql/query/getMatchBySlug"));
var getTournamentBySlug_1 = __importDefault(require("./gql/query/getTournamentBySlug"));
var getMatchesPreviewByFilters_1 = __importDefault(require("./gql/query/getMatchesPreviewByFilters"));
var getMatchesByIds_1 = __importDefault(require("./gql/query/getMatchesByIds"));
var getCategorizer_1 = __importDefault(require("./gql/query/getCategorizer"));
var getSports_1 = __importDefault(require("./gql/query/getSports"));
var getTeams_1 = __importDefault(require("./gql/query/getTeams"));
var getPlayers_1 = __importDefault(require("./gql/query/getPlayers"));
var getLiveOfTheDay_1 = __importDefault(require("./gql/query/getLiveOfTheDay"));
var getComboOfTheDay_1 = __importDefault(require("./gql/query/getComboOfTheDay"));
var getMatchOfTheDay_1 = __importDefault(require("./gql/query/getMatchOfTheDay"));
var getMatchLog_1 = __importDefault(require("./gql/query/getMatchLog"));
var getMinBet_1 = __importDefault(require("./gql/query/getMinBet"));
var getTournamentTable_1 = __importDefault(require("./gql/query/getTournamentTable"));
var getMarketTemplates_1 = __importDefault(require("./gql/query/getMarketTemplates"));
var getApplicableFreebets_1 = __importDefault(require("./gql/query/getApplicableFreebets"));
var getFreeBets_1 = __importDefault(require("./gql/query/getFreeBets"));
var getBets_1 = __importDefault(require("./gql/query/getBets"));
var getOddDynamicsByInterval_1 = __importDefault(require("./gql/query/getOddDynamicsByInterval"));
var getFavoriteSportEventsIds_1 = __importDefault(require("./gql/query/getFavoriteSportEventsIds"));
var getMatchesByEventIds_1 = __importDefault(require("./gql/query/getMatchesByEventIds"));
var getGambler_1 = __importDefault(require("./gql/query/getGambler"));
var getBanners_1 = __importDefault(require("./gql/query/getBanners"));
var getTopTournaments_1 = __importDefault(require("./gql/query/getTopTournaments"));
var getFeaturedZoneConfigs_1 = __importDefault(require("./gql/query/getFeaturedZoneConfigs"));
var getFeaturedCustomList_1 = __importDefault(require("./gql/query/getFeaturedCustomList"));
var getOddsStatistic_1 = __importDefault(require("./gql/query/getOddsStatistic"));
var getEventLiveOfTheDay_1 = __importDefault(require("./gql/query/getEventLiveOfTheDay"));
var getEventMatchOfTheDay_1 = __importDefault(require("./gql/query/getEventMatchOfTheDay"));
var getRestrictions_1 = __importDefault(require("./gql/query/getRestrictions"));
var getBannerZones_1 = __importDefault(require("./gql/query/getBannerZones"));
var getCalculateCashOut_1 = __importDefault(require("./gql/query/getCalculateCashOut"));
var getBetStakeSuggest_1 = __importDefault(require("./gql/query/getBetStakeSuggest"));
var getSportMarketsTabConfigs_1 = __importDefault(require("./gql/query/getSportMarketsTabConfigs"));
/* Mutations */
var addFavoriteSportEvents_1 = __importDefault(require("./gql/mutation/addFavoriteSportEvents"));
var deleteFavoriteSportEvents_1 = __importDefault(require("./gql/mutation/deleteFavoriteSportEvents"));
var placeBet_1 = __importDefault(require("./gql/mutation/placeBet"));
var changeGamblerSetting_1 = __importDefault(require("./gql/mutation/changeGamblerSetting"));
var changeGamblerSettings_1 = __importDefault(require("./gql/mutation/changeGamblerSettings"));
var deleteGamblerSetting_1 = __importDefault(require("./gql/mutation/deleteGamblerSetting"));
var placeCashOutOrder_1 = __importDefault(require("./gql/mutation/placeCashOutOrder"));
var changeGamblerBettingSlip_1 = __importDefault(require("./gql/mutation/changeGamblerBettingSlip"));
var generateGridEmbedVideoToken_1 = __importDefault(require("./gql/mutation/generateGridEmbedVideoToken"));
/* Subscriptions */
var onUpdateBet_1 = __importDefault(require("./gql/subscription/onUpdateBet"));
var onUpdateSportEvent_1 = __importDefault(require("./gql/subscription/onUpdateSportEvent"));
/* Subscriptions */
var matchFragment_1 = __importDefault(require("./gql/fragment/matchFragment"));
// NOTE: this exported modules will be registered in API client as API methods
var operations = {
    queries: {
        getOddDynamicsByInterval: getOddDynamicsByInterval_1.default,
        getMatchesByFilters: getMatchesByFilters_1.default,
        getMatchBySlug: getMatchBySlug_1.default,
        getTournamentBySlug: getTournamentBySlug_1.default,
        getMatchesPreviewByFilters: getMatchesPreviewByFilters_1.default,
        getMatchesByIds: getMatchesByIds_1.default,
        getCategorizer: getCategorizer_1.default,
        getSports: getSports_1.default,
        getTeams: getTeams_1.default,
        getPlayers: getPlayers_1.default,
        getLiveOfTheDay: getLiveOfTheDay_1.default,
        getComboOfTheDay: getComboOfTheDay_1.default,
        getMatchOfTheDay: getMatchOfTheDay_1.default,
        getMatchLog: getMatchLog_1.default,
        getMinBet: getMinBet_1.default,
        getTournamentTable: getTournamentTable_1.default,
        getMarketTemplates: getMarketTemplates_1.default,
        getApplicableFreeBets: getApplicableFreebets_1.default,
        getFreeBets: getFreeBets_1.default,
        getBets: getBets_1.default,
        getFavoriteSportEventsIds: getFavoriteSportEventsIds_1.default,
        getGambler: getGambler_1.default,
        getMatchesByEventIds: getMatchesByEventIds_1.default,
        getBanners: getBanners_1.default,
        getTopTournaments: getTopTournaments_1.default,
        getFeaturedZoneConfigs: getFeaturedZoneConfigs_1.default,
        getFeaturedCustomList: getFeaturedCustomList_1.default,
        getEventLiveOfTheDay: getEventLiveOfTheDay_1.default,
        getEventMatchOfTheDay: getEventMatchOfTheDay_1.default,
        getCalculateCashOut: getCalculateCashOut_1.default,
        getBannerZones: getBannerZones_1.default,
        getRestrictions: getRestrictions_1.default,
        getOddsStatistic: getOddsStatistic_1.default,
        getBetStakeSuggest: getBetStakeSuggest_1.default,
        getSportMarketsTabConfigs: getSportMarketsTabConfigs_1.default,
    },
    mutations: {
        placeBet: placeBet_1.default,
        addFavoriteSportEvents: addFavoriteSportEvents_1.default,
        deleteFavoriteSportEvents: deleteFavoriteSportEvents_1.default,
        changeGamblerSetting: changeGamblerSetting_1.default,
        changeGamblerSettings: changeGamblerSettings_1.default,
        deleteGamblerSetting: deleteGamblerSetting_1.default,
        placeCashOutOrder: placeCashOutOrder_1.default,
        changeGamblerBettingSlip: changeGamblerBettingSlip_1.default,
        generateGridEmbedVideoToken: generateGridEmbedVideoToken_1.default,
    },
    subscriptions: { onUpdateSportEvent: onUpdateSportEvent_1.default, onUpdateBet: onUpdateBet_1.default },
};
exports.default = operations;
exports.gqlFragments = {
    matchFragment: matchFragment_1.default,
};
//# sourceMappingURL=operations.js.map